import { createSlice } from "@reduxjs/toolkit";
import { API } from "../../utills/services";

const initialState = {
  firstName: "",
  lastName: "",
  mobileNumber: null,
  email: "",
  userID: "",
  token: "",
  responseCode: "",
  message: "",
  userData: JSON.parse(localStorage.getItem("user")) || null, // userData field to store extracted result
};

export const getLogin =
  ({ email, password }) =>
  async (dispatch) => {
    try {
      const url = "/Account/login";
      const response = await API.post(url, {
        email: email,
        password: password,
      });

      console.log("Login response:", response);

      if (response.status !== 200) {
        dispatch(invalidDetails(response));
        return;
      }
      // debugger
      if (response.status === 200) {
        const userData = response.data.result; // Extract result data
        dispatch(loginDetails(response)); // Keep this as is (dispatching full response)
        const expiryTime = new Date().getTime() + 8 * 60 * 60 * 1000;

        localStorage.setItem("user", JSON.stringify(userData));
        // localStorage.setItem("userType", userData.userType);
        localStorage.setItem("expiryTime", expiryTime);
      }
      return response; // Return the response for handling in the component
    } catch (error) {
      dispatch(invalidDetails(error.response));
      console.log("Login error:", error);

      throw error; // Throw the error to handle in the component
    }
  };

export const resetlogin = () => (dispatch) => {
  dispatch(resetloginDetails());
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    loginDetails: (state, { payload }) => {
      console.log('Login payload:', payload);
      
      // Store the entire response result into userData (payload is the full response)
      state.userData = payload.data.result; // Directly store the result from the response here
      state.token = payload.data.result.token;
      state.message = payload.data.message;
      state.status = payload.status; // Set a status for successful login
    },
    resetloginDetails: (state) => {
      state.firstName = "";
      state.lastName = "";
      state.mobileNumber = null;
      state.email = "";
      state.userID = "";
      state.token = "";
      state.message = "";
      state.status = null;
      state.userData = null; // Reset userData
    },
    invalidDetails: (state, { payload }) => {
      state.firstName = "";
      state.lastName = "";
      state.mobileNumber = null;
      state.email = "";
      state.userID = "";
      state.token = "";
      state.message = payload.data.message;
      state.status = payload.status;
      state.userData = null; // Reset userData on failure
    },
  },
});

export const { loginDetails, invalidDetails, resetloginDetails } =
  authSlice.actions;

export default authSlice.reducer;
